<template>
  <div style="padding-top:70px;">
    <loader></loader>
    <no-habilitado v-if="!habilitado" perfil="Arkidians"></no-habilitado>
    <app-error v-if="error" :errorMensaje="errorMensaje"></app-error>

    <div v-if="habilitado&&!error">
      <div class="row no-gutters" style="margin-top:20px; margin-left:5%; margin-bottom:20px">
        <div class="col-xs-2" style="max-width:100px">
          <router-link :to="'/Perfil/'+idUsuario" tag="h5" style="cursor:pointer">
            <arkidian
              style="background-color:#e0e0e0; border-radius:50%; width:110px; padding:20px"
              :preferencias="preferencias"
            ></arkidian>
          </router-link>
        </div>
        <div class="col-xs-10">
          <div class="card-body">
            <router-link
              :to="'/Perfil/'+idUsuario"
              tag="h5"
              style="cursor:pointer"
            >{{desafio.alias}}</router-link>

            <p class="card-text">
              <small class="text-muted">del curso {{desafio.nombre_curso}}</small>
              <br />
              <small class="text-muted">{{desafio.fechahora}}</small>
            </p>
            <div></div>
          </div>
        </div>
      </div>

      <div
        style="margin-left: 5%;
    background: #ececec;
    border-radius: 15px;
    padding-bottom: 10px;
    width: fit-content;"
      >
        <vue-load-image>
          <img slot="image" :src="desafio.url_challenge" class="imagen-challenge" />
          <img class="imagen-challenge" slot="preloader" src="public/images/site/loading.gif" />
          <div slot="error">No encontramos la imagen :-(</div>
        </vue-load-image>

        <div style="padding:10px">
          <transition name="slideAnim" type="animation" appear mode="out-in">
            <img
              v-if="desafio.ind_like==0 && (userLogged.profile != 'HIJO')"
              key="likeAdmin"
              src="public/images/site/likes.svg"
              style="width:25px;"
              alt="curso.nombre"
            />
            <img
              v-if="(desafio.ind_like==0) && (userLogged.profile == 'HIJO')"
              key="likeHijo"
              src="public/images/site/likes.svg"
              @click="darLike(desafio)"
              style="width:25px;cursor:pointer"
              alt="curso.nombre"
            />
            <img
              v-if="desafio.ind_like==1"
              key="quitaLikeHijo"
              src="public/images/site/liked.svg"
              @click="quitarLike(desafio)"
              style="width:25px;cursor:pointer"
              alt="curso.nombre"
            />
          </transition>
          <span>{{desafio.total_likes}}</span>
          <img src="public/images/site/comments.svg" style="width:25px;" alt="curso.nombre" />
          <span>{{desafio.total_comentarios}}</span>
        </div>
      </div>
    </div>

    <div style="padding-top:20px; padding-bottom:30px">
      <div
        class="card-group imagen-challenge"
        style=" margin-left:5%; border-radius:15px; display:block"
      >
        <transition-group name="slideGroup">
          <div
            class="card border-light mb-3"
            style="width:100%"
            v-for="(comentario,index) in comentarios"
            v-bind:key="index"
          >
            <div class="card-header" style="border-radius:15px">
              <router-link :to="'/Perfil/'+idUsuario" tag="b" style="cursor:pointer">
                <arkidian style="width:30px; display:inline-grid" :preferencias="comentario.preferencias"></arkidian>
                {{comentario.alias}}
              </router-link>dijo:
              <p style="margin-left:35px; padding-right:50px">{{comentario.comentario}}</p>

              <img
                v-if="comentario.ind_comentario == 1"
                src="public/images/site/delete.svg"
                @click="eliminarComentario(idDesafio, idUsuario, comentario,index)"
                style="width:30px; cursor:pointer; float:right; margin-top:-70px"
              />
            </div>
          </div>
        </transition-group>

        <div
          v-if="userLogged.profile == 'HIJO'"
          class="card-header imagen-challenge"
          style="border-radius:15px"
        >
          <a
            @click="comentar(idDesafio, idUsuario)"
            style="margin: 0px 0px 0px;
            z-index:100;
                    float: right;
                    background: #ececec;
                    padding: 4px 15px;
                    border-radius: 15px;
                    color: cornflowerblue;
                    cursor:pointer"
          >Enviar</a>
          <textarea
            v-model="newComment"
            v-on:keyup.enter="comentar(idDesafio, idUsuario)"
            type="text"
            placeholder="Dejá un comentario"
            class="comentario"
          />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import VueLoadImage from "vue-load-image";
import Loader from "../shared/Loader";
import NoHabilitado from "../shared/NoHabilitado";
import appError from "../shared/Error";
import Arkidian from "../shared/Arkidian";

export default {
  data() {
    return {
      preferencias: {
        color: "",
        body: "",
        face: "",
        hair: "",
        avatar: "",
        animated: false
      },
      habilitado: false,
      error: false,
      errorMensaje: "",
      eliminaCategoria: "",
      errorMessage: "",
      desafio: {},
      comentarios: [],
      newComment: ""
    };
  },
  computed: {
    ...mapGetters(["categorias", "userLogged", "pathAPI"])
  },
  components: {
    "vue-load-image": VueLoadImage,
    Loader: Loader,
    NoHabilitado: NoHabilitado,
    appError: appError,
    arkidian: Arkidian
  },
  props: ["idDesafio", "idUsuario"],
  methods: {
    buscarChallenge(idDesafio, idUsuario) {
      fetch(
        this.pathAPI +
          "challenge_alumno.php?usuario=" +
          this.userLogged.user +
          "&id_challenge=" +
          idDesafio +
          "&usuario_challenge=" +
          idUsuario
      )
        .then(response => response.json())
        .then(data => {
          if (data.usuario) {
            console.log(data);
            this.desafio = data;
            if (data.arkidian_usuario.length > 0) {
              console.log(data.arkidian_usuario);
              this.preferencias.color =
                "fill:#" + data.arkidian_usuario[0].color;
              this.preferencias.body = data.arkidian_usuario[0].cuerpo;
              this.preferencias.face = data.arkidian_usuario[0].cara;
              this.preferencias.hair = data.arkidian_usuario[0].pelo;
            } else {
              this.preferencias.avatar = data.avatar;
            }
            console.log(this.preferencias);
          } else {
            this.error = true;
            this.errorMensaje = "No encontramos el desafío";
          }
        });
    },
    quitarLike(desafio) {
      desafio.ind_like = 0;
      desafio.total_likes--;

      fetch(
        this.pathAPI +
          "like_challenge.php?" +
          "usuario_like=" +
          this.userLogged.user +
          "&usuario_challenge=" +
          this.idUsuario +
          "&id_challenge=" +
          this.idDesafio +
          "&secuencia=1",
        {
          method: "DELETE"
        }
      ).then(function(response) {});
    },

    darLike(desafio) {
      desafio.ind_like = 1;
      desafio.total_likes++;
      fetch(this.pathAPI + "like_challenge.php", {
        method: "POST",
        body:
          "usuario_like=" +
          this.userLogged.user +
          "&usuario_challenge=" +
          this.idUsuario +
          "&id_challenge=" +
          this.idDesafio,
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded"
        })
      }).then(function(response) {
        if (response.ok) {
          var loginResponse;
          loginResponse = response.json();
          loginResponse.then(function(result) {
            if (result.resultado == "OK") {
              return;
            } else {
              desafio.ind_like = 0;
              desafio.total_likes--;
            }
          });
        } else {
          throw "Error en la llamada Ajax";
        }
      });
    },
    buscarComentarios(idDesafio, idUsuario) {
      fetch(
        this.pathAPI +
          "comentarios.php?id_challenge=" +
          idDesafio +
          "&usuario_challenge=" +
          idUsuario +
          "&usuario=" +
          this.userLogged.user
      )
        .then(response => response.json())
        .then(data => {
          if (data.resultado == "ERROR") {
            this.error = true;
            this.errorMensaje = "al buscar comentarios";
          } else {
            this.comentarios = data;

            for (var i = 0; i < this.comentarios.length; i++) {
              console.log(this.comentarios[i])
              if (this.comentarios[i].arkidian_usuario) {
                this.comentarios[i].preferencias = {
                  color: "fill:#" + this.comentarios[i].arkidian_usuario.color,
                  body: this.comentarios[i].arkidian_usuario.cuerpo,
                  face: this.comentarios[i].arkidian_usuario.cara,
                  hair: this.comentarios[i].arkidian_usuario.pelo,
                  animated: false,
                };
              } else {
                this.comentarios[i].preferencias = {
                  avatar: this.comentarios[i].avatar
                };
              }
            }

            console.log("Comentarios")
            console.log(this.comentarios);
          }

          const loader = document.querySelector(".loader");
          loader.className += " hidden";
        });
    },
    eliminarComentario(idDesafio, idUsuario, comentario, index) {
      this.comentarios.splice(index, 1);

      fetch(
        this.pathAPI +
          "comentarios.php?id_challenge=" +
          this.idDesafio +
          "&usuario=" +
          this.userLogged.user +
          "&usuario_challenge=" +
          this.idUsuario +
          "&secuencia=" +
          comentario.secuencia,
        {
          method: "DELETE"
        }
      )
        .then(response => response.json())
        .then(data => {
          //this.comentarios.splice(index, 1);
        });
    },

    comentar(idDesafio, idUsuario) {
      console.log(this.newComment);
      if (this.newComment > " ") {
        var nuevoComentario;
        nuevoComentario = {
          usuario_comentario: sessionStorage.loggedUser,
          alias: this.userLogged.name,
          avatar: "images/site/profile.svg",
          preferencias:this.userLogged.preferencias,
          comentario: this.newComment,
          ind_comentario: "1"
        };
        this.preferencias.animated = false
        this.comentarios.push(nuevoComentario);
        console.log("usuario_challenge=" +
            idUsuario +
            "&id_challenge=" +
            idDesafio +
            "&usuario_comentario=" +
            this.userLogged.user +
            "&comentario=" +
            this.newComment)

        fetch(this.pathAPI + "comentarios.php", {
          method: "POST",
          body:
            "usuario_challenge=" +
            idUsuario +
            "&id_challenge=" +
            idDesafio +
            "&usuario_comentario=" +
            this.userLogged.user +
            "&comentario=" +
            this.newComment,
            

          headers: new Headers({
            "Content-Type": "application/x-www-form-urlencoded"
          })
        })
          .then(response => response.json())
          .then(data => {
            console.log(body)
            this.comentarios[this.comentarios.length - 1].secuencia =
              data.comentario;
            this.newComment = "";
          });
      } else {
        this.newComment = "";
      }
    }
  },
  watch: {
    $route(to, from) {
      this.error = false;
      if (this.userLogged.profile != "") {
        this.habilitado = true;
        this.buscarChallenge(this.idDesafio, this.idUsuario);
        this.buscarComentarios(this.idDesafio, this.idUsuario);
      } else {
        const loader = document.querySelector(".loader");
        loader.className += " hidden";
      }
    }
  },
  mounted: function() {
    if (this.userLogged.profile != "") {
      this.habilitado = true;
      this.buscarChallenge(this.idDesafio, this.idUsuario);
      this.buscarComentarios(this.idDesafio, this.idUsuario);
    } else {
      const loader = document.querySelector(".loader");
      loader.className += " hidden";
    }
  }
};
</script>

<style scoped>
.commentBox {
  padding: 10px;
  border-top: 1px dotted #bbb;
}
.commentBox .form-group:first-child,
.actionBox .form-group:first-child {
  width: 80%;
}
.commentBox .form-group:nth-child(2),
.actionBox .form-group:nth-child(2) {
  width: 18%;
}
.actionBox .form-group * {
  width: 100%;
}
.taskDescription {
  margin-top: 10px 0;
}
.commentList {
  padding: 0;
  list-style: none;
  max-height: 800px;
  overflow: auto;
}
.commentList li {
  margin: 0;
  margin-top: 10px;
}
.commentList li > div {
  display: table-cell;
}
.commenterImage {
  width: 48px;
  margin-right: 5px;
  height: 100%;
  float: left;
}
.image-upload > input {
  visibility: hidden;
  width: 0;
  height: 0;
}
.commenterImage img {
  width: 100%;
  border-radius: 50%;
}
.commentText p {
  margin: 0;
}
.sub-text {
  color: #aaa;
  font-family: verdana;
  font-size: 11px;
}
.actionBox {
  border-top: 1px dotted #bbb;
  padding: 10px;
}

.imagen-challenge {
  width: 800px;
  border-radius: 15px;
}

.comentario {
  width: 650px;
  height: 100px;
  border-radius: 15px;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 5px;
  border: 0px;
}

@media screen and (max-width: 900px) {
  .imagen-challenge {
    width: 500px;
  }
  .comentario {
    width: 350px;
  }
}

@media screen and (max-width: 600px) {
  .imagen-challenge {
    width: 300px;
  }
  .comentario {
    width: 180px;
  }
}

.slideGroup-enter {
  opacity: 0;
}

.slideGroup-enter-active {
  animation: slideGroup-in 1s ease-out forwards;
  transition: opacity 0.5s;
}

.slideGroup-leave-active {
  animation: slideGroup-out 1s ease-out forwards;
  transition: opacity 0.5s;
  opacity: 0;
  position: absolute;
}

.slideGroup-move {
  transition: transform 1s;
}

@keyframes slideGroup-in {
  from {
    transform: translateY(30px);
  }
  to {
    transform: translateY(0);
  }
}
@keyframes slideGroup-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(30px);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/sections/Challenge.vue